import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { EDITOR_TEMPLATE_MODIFIED, SHOW_PRODUCT_TEMPLATE_EDIT_MODAL, UNLOCK_CANVAS_EDITING, } from '../../../Rutab/RutabConstants';
import { translate } from '../../../Services/translation';
const UnlockProductTemplateEditModal = ({ fabricCanvas, }) => {
    const dispatch = useDispatch();
    const showProductTemplateEditModal = useSelector((state) => state.decalEditor.showProductTemplateEditModal);
    const handleCancel = () => {
        dispatch({
            type: SHOW_PRODUCT_TEMPLATE_EDIT_MODAL,
            payload: {
                showProductTemplateEditModal: false,
            },
        });
    };
    const handleUnlock = () => {
        dispatch({
            type: UNLOCK_CANVAS_EDITING,
        });
        dispatch({
            type: SHOW_PRODUCT_TEMPLATE_EDIT_MODAL,
            payload: {
                showProductTemplateEditModal: false,
            },
        });
        dispatch({
            type: EDITOR_TEMPLATE_MODIFIED,
        });
    };
    return (_jsx(_Fragment, { children: showProductTemplateEditModal && (_jsx("div", { className: "modal-overlay", onClick: handleCancel, style: {
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.7)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 1001,
            }, children: _jsxs("div", { className: "modal-content", onClick: (e) => e.stopPropagation(), style: {
                    backgroundColor: 'white',
                    padding: '30px',
                    borderRadius: '8px',
                    width: '400px',
                    maxWidth: '90%',
                }, children: [_jsx("div", { style: { marginBottom: '20px' }, children: _jsx("h3", { style: { margin: '0 0 20px 0', fontSize: '20px' }, children: translate('decal.template.unlock.text') }) }), _jsxs("div", { style: {
                            display: 'flex',
                            justifyContent: 'flex-end',
                            gap: '10px',
                        }, children: [_jsx("button", { onClick: handleUnlock, style: {
                                    padding: '10px 20px',
                                    background: '#f1f1f1',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    fontSize: '16px',
                                }, children: "L\u00E5s upp redigering" }), _jsx("button", { onClick: handleCancel, style: {
                                    padding: '10px 20px',
                                    background: '#f1f1f1',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    fontSize: '16px',
                                }, children: "Ok" })] })] }) })) }));
};
export default memo(UnlockProductTemplateEditModal);
